import React, { createContext } from 'react';

export interface ResourceModalInfo {
  showWarning: boolean;
  setShowWarning: React.Dispatch<React.SetStateAction<boolean>>;
  isEditing: boolean;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
  requestReturnConfirmation?: (onConfirm: () => void) => void;
}

export const ResourceModalContext = createContext<ResourceModalInfo>({
  showWarning: false,
  setShowWarning: () => {},
  isEditing: false,
  setIsEditing: () => {},
});
